import React, { useState } from 'react';
import { Box,Typography } from '@mui/material';
import { Button } from '@mui/joy';
import { useThemeContext } from '../../context/ThemeContext';


const ResendOTP = () =>{

    const { isXs, isSM, isSm, isMd} = useThemeContext()

    const [otp, setOtp] = useState({
        firstNumber: '',
        secondNumber: '',
        thirdNumber: '',
        fourthNumber: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setOtp((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
     
        alert(JSON.stringify(otp,2,null))
    };

    return (
        <>

            <Box
             
                sx={{
                    width:isSM? '100%' : isMd ? '862px' :'862px',
                   
                    height: '100vh',
                    margin: 'auto',
                    paddingTop: isSM? '1rem':'80px',
                    paddingLeft: isSM? '1rem':0,
                    paddingRight:isSM? '1rem':0,
                }}
            >
                <Typography
                    
                    variant="h6"
                    align="justify"
                    sx={{
                        width:isSM? '100%': isMd ? '862px' :'862px',
                        height:isSM? 'auto': isMd ?  '20px' : '20px',
                        padding:isSM? '1rem':0,
                        marginBottom: 2,
                        fontFamily: 'Montserrat',
                        fontSize: isSM? '16px':'22px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        color: '#666666',
                    }}
                >
                    Enter the 4-digit code that you received via SMS at +91-999-999-9999.
                </Typography>

                <form onSubmit={handleSubmit}>
                <Box
                    
                    sx={{
                        margin: 'auto',
                     
                        width:isSM? '100%' : isMd ? '558px' :'558px',
                        border: 'none',
                        height: 'auto',
                        display: 'block',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        id="otp"
                        className="inputs"
                        sx={{
                            display: 'flex',
                            justifyContent: 'left',
                            gap: 2,
                            marginTop: 2,
                            marginBottom:2
                        }}
                    >
                        
                            <input className="m-2 text-center form-control rounded" type="text" name="firstNumber" value={otp.firstNumber} onChange={handleInputChange} />
                            <input className="m-2 text-center form-control rounded" type="text" name="secondNumber" value={otp.secondNumber} onChange={handleInputChange} />
                            <input className="m-2 text-center form-control rounded" type="text" name="thirdNumber" value={otp.thirdNumber} onChange={handleInputChange} />
                            <input className="m-2 text-center form-control rounded" type="text" name="fourthNumber" value={otp.fourthNumber} onChange={handleInputChange} />
                   

                    </Box>

                    <Box sx={{ textAlign: 'center', marginTop: 3 }}>
                        <Button
                          type='submit'
                            sx={{
                                width: isSM ? '100%' : isMd ? '558px' : '558px',
                                height: '79px',
                                padding: isXs ? 0 : isSm ? '10px 20px' : isMd ? '14px 40px' : '19px 118px 20px 118px',
                                color: '#000',
                                background: '#28A745',
                                fontSize: isXs ? '14px' : isSm ? '14px' : isMd ? '24px': '24px',
                                borderRadius: '12px',
                                fontWeight:400,
                                lineHeight: '20px',
                                '&:hover': {
                                    backgroundColor: '#28A745',
                                },
                            }}
                        >
                            Submit
                        </Button>

                        <Typography
                            variant="body2"
                            sx={{ mt:3,mb:1, textAlign: 'right', marginRight: '5px', fontSize:'18px' }}
                        >
                            Changed your mobile number?
                        </Typography>

                      
                        <Button
                            sx={{
                                width: isSM ? '100%' : isMd ? '558px' : '558px',
                                height: '79px',
                                padding: isXs ? 0 : isSm ? 0 : isMd ? '14px 40px' : '19px 118px 20px 118px',
                                color: '#000',
                                backgroundColor:'#f0f0f0',
                                border:'0.5px solid #000000' ,
                                fontSize: isXs ? '14px' : isSm ? '14px' : isMd ? '24px': '24px',
                                borderRadius: '12px',
                                fontWeight: 400,
                                lineHeight: '20px',
                                '&:hover': {
                                    backgroundColor: '#f0f0f0',
                                },
                            }}
                        >
                        Resend OTP?
                        </Button>

                    </Box>
                </Box>
                </form>

                
            </Box>


        </>
    )
}

export default ResendOTP;